module.exports = __webpack_public_path__ + "static/2401b537e5207009f1920e4dd52933eab8d6fbc2998bcbc3ac985053c9bda75b-e717147bfea83105591348f53a9cc9e6.png";